/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_add_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Přidat do košíku`
};

const da_add_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Læg i kurv`
};

const de_add_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `In den Warenkorb`
};

const en_add_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Add to cart`
};

const es_add_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Añadir al carrito`
};

const fr_add_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Ajouter au panier`
};

const hu_add_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Hozzáadás a kosárhoz`
};

const it_add_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Aggiungi al carrello`
};

const nl_add_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Toevoegen aan winkelwagen`
};

const pl_add_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Dodaj do koszyka`
};

const pt_add_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Adicionar ao carrinho`
};

const sv_add_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Lägg till i kundvagnen`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const add_to_cart = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.add_to_cart(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("add_to_cart", locale)
	if (locale === "cs") return cs_add_to_cart(inputs)
	if (locale === "da") return da_add_to_cart(inputs)
	if (locale === "de") return de_add_to_cart(inputs)
	if (locale === "en") return en_add_to_cart(inputs)
	if (locale === "es") return es_add_to_cart(inputs)
	if (locale === "fr") return fr_add_to_cart(inputs)
	if (locale === "hu") return hu_add_to_cart(inputs)
	if (locale === "it") return it_add_to_cart(inputs)
	if (locale === "nl") return nl_add_to_cart(inputs)
	if (locale === "pl") return pl_add_to_cart(inputs)
	if (locale === "pt") return pt_add_to_cart(inputs)
	return sv_add_to_cart(inputs)
};